module.exports = __webpack_public_path__ + "img/save.7f098ea4.svg";